import { useFlags } from "flagsmith/react";

import { benefitsBannerContent } from "../content/benefitsBannerContent";
import { BenefitsBannerContent } from "../types/BenefitsBanner.types";
import { GLOBAL_FLAGS_ENUM } from "@utils/featureFlags";

export interface UseBenefitsBannerFlagsResult {
  /** `true` quando a flag Flagsmith está habilitada. */
  isEnabled: boolean;
  /** Conteúdo não-visual da campanha (texto alternativo + destino do CTA). */
  content: BenefitsBannerContent;
}

/**
 * Resolve, em um único lugar, se o banner de benefícios deve ser exibido.
 * Consumido uma vez pela tela Home.
 */
export const useBenefitsBannerFlags = (): UseBenefitsBannerFlagsResult => {
  const flags = useFlags([GLOBAL_FLAGS_ENUM.BENEFITS_BANNER_FLAG]);
  const isEnabled =
    flags[GLOBAL_FLAGS_ENUM.BENEFITS_BANNER_FLAG]?.enabled === true;

  return {
    isEnabled,
    content: benefitsBannerContent,
  };
};

export default useBenefitsBannerFlags;
